import { LitElement, html } from "lit-element";
import { router } from "lit-element-router";
import "./router-outlet";
import "./target-link";
import "../pages/register-page";
import "../pages/login-page";
import "../pages/activate-page";
import "../pages/forgot-password-page";
import "../pages/reset-password-page";

class App extends router(LitElement) {
  route: string;
  params: {};
  query: {};

  protected createRenderRoot() {
    return this;
  }

  static get properties() {
    return {
      route: { type: String },
      params: { type: Object },
      query: { type: Object },
    };
  }

  static get routes() {
    return [
      {
        name: "login",
        pattern: "",
        data: { title: "Sign in" },
      },
      {
        name: "register",
        pattern: "register",
        data: { title: "Sign up" },
      },
      {
        name: "reset-password",
        pattern: "reset-password",
        data: { title: "Reset password" },
      },
      {
        name: "forgot-password",
        pattern: "forgot-password",
        data: { title: "Forgot Password" },
      },
      {
        name: "activate",
        pattern: "activate",
        data: { title: "Activate account" },
      },
    ];
  }

  constructor() {
    super();
    this.route = "";
    this.params = {};
    this.query = {};
  }

  router(route, params, query, data) {
    this.route = route;
    this.params = params;
    this.query = query;
  }

  render() {
    return html`
      <router-outlet active-route=${this.route}>
        <reset-password-page route="reset-password"></reset-password-page>
        <login-page route="login"></login-page>
        <register-page route="register"></register-page>
        <forgot-password-page route="forgot-password"></forgot-password-page>
        <activate-page route="activate"></activate-page>
      </router-outlet>
    `;
  }
}

customElements.define("app-container", App);
